// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__33rF7","footer":"ModalCreateQualiphyProcedure_footer__3sl8A","additionData":"ModalCreateQualiphyProcedure_additionData__1QB2c"};